var map = {
	"./achievements.js": 59595,
	"./animations.js": 57412,
	"./auth.js": 21441,
	"./bonusslot.js": 34608,
	"./cards.js": 14748,
	"./champions.js": 78379,
	"./chat.js": 88705,
	"./cookieManager.js": 57150,
	"./events.js": 33242,
	"./externalScripts.js": 43826,
	"./gameplay.js": 80203,
	"./index.js": 13419,
	"./kingspath.js": 28176,
	"./missions.js": 11028,
	"./news.js": 93012,
	"./popups.js": 91936,
	"./seasonPass.js": 66799,
	"./shop.js": 19971,
	"./sound.js": 10988,
	"./teams.js": 37633,
	"./tournaments.js": 52047,
	"./treasury.js": 49470,
	"./user.js": 86400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78043;